/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_No_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "No event selected" |
*
* @param {Notes_No_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_no_event_aria_label = /** @type {((inputs?: Notes_No_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_No_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Veranstaltung ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие не выбрано")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ningún evento seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई इवेंट चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento selecionado")
	return /** @type {LocalizedString} */ ("No event selected")
});